import React, { useState, useEffect } from 'react';
import './App.css';

const formatDate = (dateString) => {
  const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
  const date = new Date(dateString);
  return date.toLocaleDateString(undefined, options);
};

const HomePage = () => {
  const [personelData, setPersonelData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedDate, setSelectedDate] = useState(new Date().toISOString().split('T')[0]);

  useEffect(() => {
    const fetchPersonelData = async () => {
      try {
        const response = await fetch(`https://api.idekod.com.tr/login/person?date=${selectedDate}`);

        if (!response.ok) {
          const errorData = await response.text();
          throw new Error(`Network response was not ok: ${response.status} ${response.statusText} - ${errorData}`);
        }

        const data = await response.json();
        setPersonelData(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchPersonelData();
  }, [selectedDate]);

  const handleDateChange = (e) => setSelectedDate(e.target.value);

  return (
    <div className="page">
      <div className="page__head">
        <div>
          <h1 className="page__title">Giriş / Çıkış Takibi</h1>
          <p className="page__subtitle">Seçilen güne ait personel hareketleri</p>
        </div>
      </div>

      <div className="card">
        <div className="card__header card__header--row">
          <h2 className="card__title">Personel Giriş / Çıkış Bilgileri</h2>
          <div className="form-field" style={{ maxWidth: 240 }}>
            <label htmlFor="date-picker" className="form-label">Tarih</label>
            <input
              className="form-control"
              type="date"
              id="date-picker"
              value={selectedDate}
              onChange={handleDateChange}
              max={new Date().toISOString().split('T')[0]}
            />
          </div>
        </div>

        {loading && (
          <div className="state-block">
            <span className="spinner" aria-hidden="true" />
            <span>Kayıtlar yükleniyor…</span>
          </div>
        )}

        {!loading && error && (
          <div className="state-block state-block--error">
            <span>Kayıtlar alınamadı.</span>
            <span className="form-helper">{error}</span>
          </div>
        )}

        {!loading && !error && (
          <div className="table-wrapper">
            <table className="data-table">
              <thead>
                <tr>
                  <th>Ad Soyad</th>
                  <th>Tarih</th>
                  <th>Giriş Saati</th>
                  <th>Çıkış Saati</th>
                  <th>Durum</th>
                </tr>
              </thead>
              <tbody>
                {personelData.length > 0 ? (
                  personelData.map((personel) => {
                    const isExit = personel.DURUM === 2;
                    return (
                      <tr key={personel.id}>
                        <td data-label="Ad Soyad">{personel.RNAME}</td>
                        <td data-label="Tarih">{formatDate(personel.DATEG)}</td>
                        <td data-label="Giriş Saati">{personel.TIMEG}</td>
                        <td data-label="Çıkış Saati">{personel.TIMEC}</td>
                        <td data-label="Durum">
                          <span className={`badge ${isExit ? 'badge--danger' : 'badge--success'}`}>
                            {isExit ? 'Çıkış Yaptı' : 'Giriş Yaptı'}
                          </span>
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr className="empty-row">
                    <td colSpan="5">Bu tarihte kaydınız yoktur.</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default HomePage;
